"use strict";

export default {
  createdDokInDokart: "CREATED_DOK_DOKART",
  deletedDokInDokart: "DELETED_DOK_DOKART",
};
